module.exports = __webpack_public_path__ + "img/DE01667.74da500e.png";